import { Injectable } from '@angular/core';
import { AppliedFilters } from '../../shared-components/panel-hub/models/applied-filters';
import { PaginationState } from '../../shared-components/panel-hub/models/pagination-state';
import { BaseSearchRequest } from '../models/search/base-search-request';
import { FilterCriteriaDto, FilterInfoDto } from '../models/search/filter-dto';
import { PaginationDto } from '../models/search/pagination-dto';
import { SortCriteriaDto, SortFieldDto } from '../models/search/sort-dto';
import { SortCriteria } from '../../shared-components/panel-hub/models/sort-criteria';
import { FilterCriteria } from '../../shared-components/panel-hub/models/filter-criteria';

@Injectable({ providedIn: 'root' })
export class SearchMapperService {
    mapToBaseSearchRequest(
        filters?: AppliedFilters | null,
        sort?: SortCriteria | null,
        pagination?: PaginationState | null
    ): BaseSearchRequest {
        const payload: BaseSearchRequest = {
            Filter: this.mapFilters(filters),
            Sort: this.mapSort(sort),
            Pagination: this.mapPagination(pagination)
        };
        return payload;
    }

    private mapPagination(pagination?: PaginationState | null): PaginationDto {
        return {
            PageNumber: pagination?.pageNumber ?? 1,
            PageSize: pagination?.pageSize ?? 25
        };
    }

    private mapFilters(filters?: AppliedFilters | null): FilterCriteriaDto | null {
        if (!filters) {
            return null;
        }
        const filtersList = Array.isArray(filters.filters) ? (filters.filters as FilterCriteria[]) : [];
        const filterInfoList: FilterInfoDto[] = filtersList.map(filterItem => ({
            Field: filterItem.field,
            Values: (filterItem.values || []).map(v => {
                if (v instanceof Date) {
                    return v.toISOString();
                }
                return String(v);
            }),
            Type: filterItem.type
        }));

        const filterCriteria: FilterCriteriaDto = {
            SearchText: filters.searchText ?? null,
            FilterItems: filterInfoList
        };
        return filterCriteria;
    }

    private mapSort(sort?: SortCriteria | null): SortCriteriaDto | null {
        if (!sort) {
            return null;
        }
        const sortField: SortFieldDto = {
            field: sort.field,
            sortDirection: sort.sortDirection,
            type: sort.type
        } as SortFieldDto;

        const sortCriteria: SortCriteriaDto = { Fields: [sortField] } as SortCriteriaDto;
        return sortCriteria;
    }
}
